export type DocumentOwnerDisplayFields = {
  id: number
  username?: string
  first_name?: string
  last_name?: string
}

export function formatOwnerLabel(user: DocumentOwnerDisplayFields | null | undefined): string {
  if (!user?.id) return ''
  if (user.first_name && user.last_name) return `${user.first_name} ${user.last_name}`
  if (user.username) return user.username
  return String(user.id)
}

export interface DocumentOwnerSource {
  owner?: number | DocumentOwnerDisplayFields | null
  owner_display?: DocumentOwnerDisplayFields | null
}

export function ownerDisplayFromDocument(document: DocumentOwnerSource | null | undefined): DocumentOwnerDisplayFields | null {
  if (!document) return null
  if (document.owner_display) return document.owner_display
  if (document.owner && typeof document.owner === 'object') {
    const o = document.owner as DocumentOwnerDisplayFields
    if (o.id != null) {
      return {
        id: o.id,
        username: o.username,
        first_name: o.first_name,
        last_name: o.last_name,
      }
    }
  }
  return null
}

export function getDocumentOwnerDisplayName(
  document: DocumentOwnerSource,
  usersCache: DocumentOwnerDisplayFields[],
  usersCacheLoaded: boolean
): string {
  const { owner, owner_display } = document
  if (owner && typeof owner === 'object') {
    return formatOwnerLabel(owner as DocumentOwnerDisplayFields)
  }
  if (owner_display) {
    return formatOwnerLabel(owner_display)
  }
  const ownerId = typeof owner === 'number' ? owner : null
  if (!ownerId) return ''
  if (usersCacheLoaded && usersCache.length > 0) {
    const user = usersCache.find((u) => u.id === ownerId)
    if (user) return formatOwnerLabel(user)
  }
  return ownerId.toString()
}
